export default "/static/media/500.5c304b99.webm";